import { useApiClient } from '@m43/core';
import { UserpollResource } from '@mark43/rms-api';
import { useEffect } from 'react';
import { useBroadcast } from '../common/broadcast-channel/use-broadcast';
import {
    useFullscreenModalControls,
    useFullscreenModalState,
} from '../modals/context/modal-context-provider';

export function SessionTimeoutManager(props: { children: React.ReactNode }) {
    const apiClient = useApiClient();
    const modalControls = useFullscreenModalControls();
    const modalState = useFullscreenModalState();

    const { postMessage } = useBroadcast('session-timeout-modal', (msg) => {
        if (msg.type === 'OPEN_SESSION_TIMEOUT_MODAL') {
            modalControls.open({
                type: 'SESSION_TIMEOUT_MODAL',
                props: {},
            });
        }
    });

    useEffect(() => {
        const intervalID = setInterval(() => {
            apiClient
                .request<UserpollResource.PollUser>({
                    method: 'GET',
                    url: 'user/poll',
                    service: 'RMS',
                })
                .then((response) => {
                    const expirationSeconds = response.data.data?.expirationSeconds;
                    if (
                        expirationSeconds &&
                        // we poll every minute, so we leave a one minute margin of error to notify the user
                        // of a session ending with _at least_ 5 minutes of notice
                        expirationSeconds < 360 &&
                        modalState?.type !== 'SESSION_TIMEOUT_MODAL'
                    ) {
                        modalControls.open({
                            type: 'SESSION_TIMEOUT_MODAL',
                            props: {},
                        });
                        postMessage({
                            type: 'OPEN_SESSION_TIMEOUT_MODAL',
                        });
                    }
                });
        }, 60_000);
        return () => {
            clearInterval(intervalID);
        };
    }, [apiClient, modalControls, modalState?.type, postMessage]);
    return <>{props.children}</>;
}
